import s from "./index4.js";
import { resolveComponent as n, openBlock as e, createElementBlock as a, normalizeClass as g, createBlock as t, createCommentVNode as l } from "vue";
import "./index5.js";
import B from "../../../../_virtual/index.js";
function p(o, L, u, d, c, C) {
  const r = n("LogoSSL"), m = n("LogoPCI"), i = n("LogoBBB");
  return e(), a("div", {
    class: g([
      "trust-logos",
      o.isSelectionStyle ? "selection-page-experiment" : ""
    ])
  }, [
    o.logoSSL.shouldRender && !o.isSimpleLogo ? (e(), t(r, {
      key: 0,
      htmlContent: o.logoSSL.htmlContent
    }, null, 8, ["htmlContent"])) : l("", !0),
    o.logoPCI.shouldRender && !o.isSimpleLogo ? (e(), t(m, {
      key: 1,
      htmlContent: o.logoPCI.htmlContent
    }, null, 8, ["htmlContent"])) : l("", !0),
    o.logoBBB.shouldRender ? (e(), t(i, {
      key: 2,
      link: o.logoBBB.link,
      imageLink: o.logoBBB.imageLink,
      imageAlternateText: o.logoBBB.imageAlternateText
    }, null, 8, ["link", "imageLink", "imageAlternateText"])) : l("", !0)
  ], 2);
}
const I = /* @__PURE__ */ B(s, [["render", p], ["__scopeId", "data-v-6fbaeee3"]]);
export {
  I as default
};
//# sourceMappingURL=index3.js.map
